var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value === true)?_c('b-badge',{attrs:{"variant":_vm.trueValueBadgeVariant}},[_vm._v(" "+_vm._s(_vm.trueValueText)+" ")]):(_vm.value === false)?_c('b-badge',{attrs:{"variant":_vm.falseValueBadgeVariant}},[_vm._v(" "+_vm._s(_vm.falseValueText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }